(function(){
  /* Mobile menu: open/close sub-menus (accordion) */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-subtoggle]');
    if (!b) return;
    e.preventDefault();
    var item = b.closest('.rm-nav__item');
    if (!item) return;
    var open = item.classList.toggle('is-expanded');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Reset the mobile menu when the screen becomes desktop size */
  var nav = document.querySelector('[data-nav]');
  var toggle = document.querySelector('[data-menu-toggle]');
  function reset(){
    if (!nav) return;
    nav.classList.remove('is-open');
    nav.querySelectorAll('.is-expanded').forEach(function(i){ i.classList.remove('is-expanded'); });
    nav.querySelectorAll('[data-subtoggle]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    if (toggle){ toggle.setAttribute('aria-expanded','false'); var ic = toggle.querySelector('.ms'); if (ic) ic.textContent = 'menu'; }
  }
  if (window.matchMedia){
    var mq = window.matchMedia('(min-width: 990px)');
    var onChange = function(){ if (mq.matches) reset(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
  }
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) { reset(); if (toggle) toggle.focus(); }
  });
})();
